import { Component, ElementRef, HostListener, Input, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-video-player-new',
  templateUrl: './video-player-new.component.html',
  styleUrls: ['./video-player-new.component.scss']
})
export class VideoPlayerNewComponent {

  @Input() srcVideo!: string;
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;

  isPlaying: boolean = false;
  currentTime: number = 0;
  isFullScreen: boolean = false;
  isLoading: boolean = false;
  controlsVisible: boolean = false;
  controlTimeout: any;
  progressPercent: number = 0;

  // تابع برای تشخیص دستگاه موبایل
   isMobileDevice(): boolean {
     return /Mobi|Android/i.test(navigator.userAgent);
   }

  // Play or pause the video
  togglePlayPause() {
    const video: HTMLVideoElement = this.videoPlayer.nativeElement;
    if (video.paused) {
      video.play();
      this.isPlaying = true;
      this.hideControlsAfterDelay();
    } else {
      video.pause();
      this.isPlaying = false;
      this.controlsVisible = true;
    }
  }

  // نشان دادن کنترل‌ها و مخفی کردن آنها بعد از مدتی
  showControls() {
    this.controlsVisible = true;
    if (this.isPlaying) {
      this.hideControlsAfterDelay(); // اگر ویدیو پخش می‌شود، کنترل‌ها بعد از مدتی مخفی شوند
    }
  }

  hideControlsAfterDelay() {
    if (this.controlTimeout) {
      clearTimeout(this.controlTimeout);
    }
    this.controlTimeout = setTimeout(() => {
      this.controlsVisible = false;
    }, 3000); // کنترل‌ها بعد از ۳ ثانیه مخفی می‌شوند
  }

  toggleVideoScreen() {
    if (this.isFullScreen) {
      // ====[Exit fullscreen mode]===
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if ((document as any).webkitExitFullscreen) { /* Safari */
        (document as any).webkitExitFullscreen();
      } else if ((document as any).mozCancelFullScreen) { /* Firefox */
        (document as any).mozCancelFullScreen();
      } else if ((document as any).msExitFullscreen) { /* IE/Edge */
        (document as any).msExitFullscreen();
      }
  
      // بازگرداندن حالت چرخش صفحه به حالت اصلی، فقط برای موبایل
      if (this.isMobileDevice() && (screen.orientation as any).unlock) {
        (screen.orientation as any).unlock();
      }
  
      this.isFullScreen = false;
    } else {
      const videoContainer = this.videoPlayer.nativeElement.parentElement as HTMLElement;

      // ====[Enter fullscreen mode]===
      if (videoContainer.requestFullscreen) {
        videoContainer.requestFullscreen();
      } else if ((videoContainer as any).webkitRequestFullScreen) { /* Safari */
        (videoContainer as any).webkitRequestFullScreen();
      } else if ((videoContainer as any).mozRequestFullScreen) { /* Firefox */
        (videoContainer as any).mozRequestFullScreen();
      } else if ((videoContainer as any).msRequestFullscreen) { /* IE/Edge */
        (videoContainer as any).msRequestFullscreen();
      }
  
      // قفل کردن صفحه به حالت افقی فقط برای موبایل
      if (this.isMobileDevice() && (screen.orientation as any).lock) {
        (screen.orientation as any).lock('landscape').catch((error: any) => {
          console.error("Failed to lock the orientation:", error);
        });
      }
  
      this.isFullScreen = true;
    }
  }
  
  

  // Update progress bar based on video time
  updateProgressBar() {
    const video: HTMLVideoElement = this.videoPlayer.nativeElement;
  
    this.currentTime = video.currentTime || 0;
  
    const duration = video.duration;
  
    if (!duration || duration === 0) return;

    this.progressPercent = (this.currentTime / duration) * 100;
  }

  // Seek video based on the progress bar
  seekVideo() {
    const video: HTMLVideoElement = this.videoPlayer.nativeElement;
    video.currentTime = this.currentTime;
  }

  // Format time to mm:ss
  formatTime(seconds: number | undefined): string {
    if (!seconds) return '0:00';
    const minutes = Math.floor(seconds / 60);
    const sec = Math.floor(seconds % 60);
    return minutes + ':' + (sec < 10 ? '0' : '') + sec;
  }

  // Show loader when video is buffering
  showLoader() {
    this.isLoading = true;
  }

  // Hide loader when video is ready to play
  hideLoader() {
    this.isLoading = false;
  }

  // Listen for changes to the fullscreen state (e.g., if the user presses ESC to exit fullscreen)
  @HostListener('document:fullscreenchange', [])
  @HostListener('document:webkitfullscreenchange', [])
  @HostListener('document:mozfullscreenchange', [])
  @HostListener('document:MSFullscreenChange', [])
  onFullScreenChange() {
    if (!document.fullscreenElement) {
      this.isFullScreen = false;
      
      // بازگرداندن چرخش صفحه به حالت اصلی، فقط برای موبایل
      if (this.isMobileDevice() && screen.orientation && screen.orientation.unlock) {
        screen.orientation.unlock();
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['srcVideo'] && !changes['srcVideo'].firstChange) {
      this.loadVideo();
    }
  }
  
  loadVideo() {
    const video: HTMLVideoElement = this.videoPlayer.nativeElement;
    video.src = this.srcVideo; // ویدیو را با آدرس جدید بارگذاری می‌کنیم
    video.load();
    this.isPlaying = false; // حالت پخش را تنظیم می‌کنیم
  }

  bufferedPercent: number = 0;

  updateBuffered() {
    const video = this.videoPlayer.nativeElement;
  
    if (!video.buffered.length || !video.duration) return;
  
    // آخرین نقطه بافر شده
    const bufferedEnd = video.buffered.end(video.buffered.length - 1);
  
    this.bufferedPercent = (bufferedEnd / video.duration) * 100;
  }

}
